<template>
    <jb-buttons no-wrap>
        <jb-button color="danger" class="buttons" :icon="mdiTrashCan" small @click="deleteAction" />
    </jb-buttons>
</template>
<script>
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import { mdiCircleEditOutline, mdiTrashCan, mdiMagnify, mdiAccount } from '@mdi/js'
        export default {
        name: 'ButtonActionRender',
        components: { JbButton, JbButtons },
        setup (props) {
            return {
                mdiCircleEditOutline,
                mdiTrashCan,
                mdiAccount,
                mdiMagnify
            }
        },

        methods: {
            deleteAction () {
                console.log('deleteAction >>>> ', this.params.data.id)
                this.params.context.componentParent.deleteModalShow(this.params.data)
            }
        }
    }
</script>
